<div
    class="alert"
    [ngClass]="{
        'alert--blue' : alert == 'info',
        'alert--orange' : alert == 'warning',
        'alert--green' : alert == 'success',
        'alert--red' : alert == 'danger'
    }"
>
    <img class="alert__icon" mfpLazyImage lazySrc="assets/icons/{{alert}}.svg" alt="">
    <ng-content></ng-content>
</div>